import React, { useState, useEffect } from 'react';

const ROLES = ['member', 'readonly', 'admin', 'superadmin'];

const overlayStyle = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex', justifyContent: 'center', alignItems: 'center',
  zIndex: 9999,
};

const modalStyle = {
  background: '#fff', borderRadius: '8px',
  padding: '28px', width: '500px', maxWidth: '95vw',
  boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
};

const UserEditModal = ({ user, onSave, onClose, loading }) => {
  const [form, setForm] = useState({
    role: '',
    is_active: true,
    is_socio_cai: false,
    num_socio_cai: '',
    is_socio_penia: false,
    num_socio_penia: '',
  });

  useEffect(() => {
    if (user) setForm({
      role: user.role,
      is_active: user.is_active,
      is_socio_cai: user.is_socio_cai || false,
      num_socio_cai: user.num_socio_cai || '',
      is_socio_penia: user.is_socio_penia || false,
      num_socio_penia: user.num_socio_penia || '',
    });
  }, [user]);

  if (!user) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(user.id, form);
  };

  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
        <h5 style={{ marginBottom: '4px' }}>Editar usuario</h5>
        <p style={{ color: '#888', fontSize: '0.9rem', marginBottom: '20px' }}>
          {user.email}
        </p>

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Rol</label>
            <select
              className="form-select"
              value={form.role}
              onChange={(e) => setForm({ ...form, role: e.target.value })}
            >
              {ROLES.map((r) => (
                <option key={r} value={r}>
                  {r.charAt(0).toUpperCase() + r.slice(1)}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-4">
            <label className="form-label">Estado</label>
            <div style={{ display: 'flex', gap: '12px' }}>
              <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <input
                  type="radio"
                  name="is_active"
                  checked={form.is_active === true}
                  onChange={() => setForm({ ...form, is_active: true })}
                />
                <span style={{ color: '#388E3C', fontWeight: 600 }}>✓ Activo</span>
              </label>
              <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <input
                  type="radio"
                  name="is_active"
                  checked={form.is_active === false}
                  onChange={() => setForm({ ...form, is_active: false })}
                />
                <span style={{ color: '#C73B33', fontWeight: 600 }}>✗ Inactivo</span>
              </label>
            </div>
          </div>

          {/* Socio CAI */}
          <div className="mb-3">
            <label className="form-label" style={{ fontWeight: 600 }}>Socio CAI</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
              <div className="form-check form-switch" style={{ margin: 0 }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={form.is_socio_cai}
                  onChange={(e) => setForm({ ...form, is_socio_cai: e.target.checked, num_socio_cai: e.target.checked ? form.num_socio_cai : '' })}
                  style={{ cursor: 'pointer' }}
                />
              </div>
              <span style={{ color: form.is_socio_cai ? '#388E3C' : '#888', fontSize: '0.9rem' }}>
                {form.is_socio_cai ? 'Es socio CAI' : 'No es socio CAI'}
              </span>
            </div>
            {form.is_socio_cai && (
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Nº de socio CAI"
                value={form.num_socio_cai}
                onChange={(e) => setForm({ ...form, num_socio_cai: e.target.value })}
                maxLength={50}
              />
            )}
          </div>

          {/* Socio Peña */}
          <div className="mb-4">
            <label className="form-label" style={{ fontWeight: 600 }}>Socio Peña</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
              <div className="form-check form-switch" style={{ margin: 0 }}>
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={form.is_socio_penia}
                  onChange={(e) => setForm({ ...form, is_socio_penia: e.target.checked, num_socio_penia: e.target.checked ? form.num_socio_penia : '' })}
                  style={{ cursor: 'pointer' }}
                />
              </div>
              <span style={{ color: form.is_socio_penia ? '#388E3C' : '#888', fontSize: '0.9rem' }}>
                {form.is_socio_penia ? 'Es socio de la Peña' : 'No es socio de la Peña'}
              </span>
            </div>
            {form.is_socio_penia && (
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Nº de socio Peña"
                value={form.num_socio_penia}
                onChange={(e) => setForm({ ...form, num_socio_penia: e.target.value })}
                maxLength={50}
              />
            )}
          </div>

          <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn"
              style={{ backgroundColor: '#C73B33', color: '#fff' }}
              disabled={loading}
            >
              {loading ? 'Guardando...' : 'Guardar cambios'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserEditModal;
